import React from 'react';
import { PanGestureHandler } from 'react-native-gesture-handler';
import Animated, { useSharedValue, useAnimatedGestureHandler, useAnimatedStyle, withSpring, interpolate, runOnJS } from 'react-native-reanimated';
const SWIPE_AWAY = -30;

const Swipeable = props => {
  const {
    children,
    onSwipeAway
  } = props;
  const transY = useSharedValue(0);
  const onGestureEvent = useAnimatedGestureHandler({
    onStart: (_, ctx) => {
      ctx.startY = transY.value;
    },
    onActive: (event, ctx) => {
      transY.value = interpolate(ctx.startY + event.translationY, [0, 4], [0, 1]);
    },
    onEnd: event => {
      if (event.velocityY < SWIPE_AWAY && onSwipeAway) {
        runOnJS(onSwipeAway)();
      } else {
        transY.value = withSpring(0);
      }
    }
  });
  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [{
        translateY: transY.value
      }]
    };
  });
  return /*#__PURE__*/React.createElement(PanGestureHandler, {
    onGestureEvent: onGestureEvent
  }, /*#__PURE__*/React.createElement(Animated.View, {
    style: animatedStyle
  }, children));
};

export default Swipeable;
//# sourceMappingURL=Swipeable.js.map